var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AchooInputComponent } from '../achoo-input/achoo-input.component';
import { IonRangeSliderComponent } from 'ng2-ion-range-slider/lib/ion-range-slider.component';
import { CommonConstant } from '../../app.constants';
import { ValidationHandlerService } from '../validation-handler.service';
var AchooSliderComponent = /** @class */ (function (_super) {
    __extends(AchooSliderComponent, _super);
    function AchooSliderComponent(validationHandlerService) {
        var _this = _super.call(this, validationHandlerService) || this;
        _this.validationHandlerService = validationHandlerService;
        _this.dataType = 'number';
        _this.overMaxValue = false;
        return _this;
    }
    AchooSliderComponent.prototype.ngOnInit = function () {
        this.minValue = this.from;
        this.maxValue = this.to;
    };
    AchooSliderComponent.prototype.ngOnDestroy = function () {
        if (this.sliderElement) {
            this.sliderElement.destroy();
        }
    };
    AchooSliderComponent.prototype.onChange = function (e) {
        this.minValue = e.from;
        this.maxValue = e.to;
        this.onModelChange({ from: e.from, to: e.to });
        if (this.maxValue < this.max) {
            this.overMaxValue = false;
        }
        else {
            this.overMaxValue = true;
        }
    };
    AchooSliderComponent.prototype.isNumber = function () {
        return this.dataType === CommonConstant.NUMBER_DATA_TYPE;
    };
    AchooSliderComponent.prototype.isPercent = function () {
        return this.dataType === CommonConstant.PERCENT_DATA_TYPE;
    };
    AchooSliderComponent.prototype.resetSlider = function () {
        this.minValue = this.min;
        this.maxValue = this.max;
    };
    AchooSliderComponent.prototype.updateRangeValue = function (min, max) {
        if (min) {
            this.from = min;
            this.minValue = min;
        }
        if (max) {
            this.to = max;
            this.maxValue = max;
        }
    };
    AchooSliderComponent.prototype.isMaximumValue = function (endValue) {
        return endValue && endValue === this.max;
    };
    return AchooSliderComponent;
}(AchooInputComponent));
export { AchooSliderComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-slider/achoo-slider.component.ts.pre-build-optimizer.js